function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { linearGradient } from 'searchband-frontend-commons/util/css';
import { PREDEFINED_TYPE, PREDEFINED_SIZE } from '../../data-parser/div-cards/props/predefined-size';
import { NUMERIC_TYPE } from '../../data-parser/div-cards/props/numeric-size';
import { BACKGROUND_TYPE } from '../../data-parser/div-cards/props/background';

/**
 * Получения стилей для бэкграунда
 * @param  {Object} background
 * @return {Object}
 */
export var getBackgroundStyle = function getBackgroundStyle() {
    var background = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = background.type;


    switch (type) {
        case BACKGROUND_TYPE.solid:
            return { backgroundColor: background.color };
        case BACKGROUND_TYPE.gradient:
            return linearGradient({
                startColor: background.startColor,
                endColor: background.endColor
            });
        case BACKGROUND_TYPE.image:
            return {
                backgroundImage: 'url(' + background.imageUrl + ')',
                backgroundSize: 'cover',
                backgroundPostion: 'center'
            };
        default:
            return {};
    }
};

/**
 * Перевести размер в css свойство
 * @param {Object} size
 * @param {String} defaultValue
 * @return {String}
 */
export var sizeTraitToCssUnit = function sizeTraitToCssUnit(size) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';

    if (!size) {
        return defaultValue;
    }

    switch (size.type) {
        case NUMERIC_TYPE:
            return '' + size.value + size.unit;
        case PREDEFINED_TYPE:
            return size.value === PREDEFINED_SIZE.matchParent ? '100%' : 'auto';
        default:
            defaultValue;
    }
};

/**
 * Перевести размер в bem модификатор
 * @param {Object} size
 * @return {Object}
 */
export var sizeTraitToClassMode = function sizeTraitToClassMode(size) {
    if (!size || size.type === NUMERIC_TYPE) {
        return {};
    }

    return _defineProperty({}, size.type, size.value);
};

/**
 * Явлеяется ли размер блока заранее установленным
 * @param {String} size.type
 * @return {Boolean}
 */
export var isSizeDefined = function isSizeDefined(size) {
    if (!size) {
        return false;
    }

    if (size.type === NUMERIC_TYPE) {
        return true;
    }

    if (size.type === PREDEFINED_TYPE) {
        return size.value === PREDEFINED_SIZE.matchParent || size.value === PREDEFINED_SIZE.matchViewport;
    }

    return false;
};